import { navLinks } from "@/mocks/navData";
import { categories } from "@/mocks/categoryData";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-100">
      <div className="w-full px-4 md:px-6 pt-14 pb-8">
        <div className="mx-auto max-w-shell">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr] gap-8 lg:gap-12">
            <div>
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-lg font-bold">
                  51
                </span>
                <span className="font-heading text-lg font-semibold text-foreground-950">
                  51网址导航
                </span>
              </div>
              <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-700">
                按分类整理收录热门网站列表的导航入口站，涵盖常用工具、影视娱乐、学习资源等方向。人工逐条核对，只留还能用的靠谱好站，帮你把挑网站的时间省下来。
              </p>
              <div className="mt-5 flex items-center gap-3">
                <a
                  href="#submit"
                  className="flex items-center gap-2 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-add-circle-line"></i>
                  提交收录
                </a>
                <a
                  href="#faq"
                  className="flex items-center gap-2 px-4 py-2 rounded-md border border-secondary-300 text-secondary-900 text-sm hover:bg-secondary-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-information-line"></i>
                  收录说明
                </a>
              </div>
            </div>

            <div>
              <h3 className="font-label text-sm text-foreground-900">页面导航</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {navLinks.map((link) => (
                  <li key={link.id}>
                    <a
                      href={`#${link.id}`}
                      className="text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h3 className="font-label text-sm text-foreground-900">热门分类</h3>
              <ul className="mt-4 flex flex-col gap-3">
                {categories.slice(0, 6).map((category) => (
                  <li key={category.name}>
                    <a
                      href="#categories"
                      className="flex items-center justify-between gap-2 text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {category.name}
                      <span className="text-xs text-foreground-400">{category.count}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-6 border-t border-secondary-300 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-600">
              51网址导航 · 分类收录网站列表，帮你挑到靠谱好站
            </p>
            <p className="text-xs text-foreground-500">
              本站为静态导航展示，所有站外入口请以官方页面为准
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}